// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rp-popup-container {
  position: fixed;
  top: 1% !important;
  right: 1%;
  align-items: center;
  justify-content: space-between;
  background-color: #fffdfb;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
  z-index: 8001;
  border-radius: 8px;
  padding: 20px;
  max-width: 40%;
  transition: top 0.5s ease-in-out;
}

.rp-popup-container.visible {
  top: 0%;
}

.rp-popup-icon {
  margin-right: 5%;
  max-width: 25px;
  text-align: -webkit-center;
}

.rp-popup-items {
  margin: 5% 1%;
}

.rp-popup-header {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 1%;
}

.rp-popup-content {
  align-items: center;
  flex-grow: 1;
  width: 100%;
  /* display: flex; */
}

.rp-popup-title {
  margin-bottom: 0px !important;
  font-size: 12px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #808080;
}

.rp-popup-product-container {
  display: flex;
  align-items: center;
  margin-bottom: 2%;
  /* background: #f0f0f05c; */
  border-radius: 3px;
  padding: 0 1%;
}

.rp-popup-image {
  height: 3.4em;
  object-fit: cover;
  border-radius: 3px;
}

.rp-popup-product-title {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0em !important;
  margin-left: 1em;
  color: black;
}

.rp-popup-buttons {
  align-items: center;
  width: 100%;
  justify-content: space-between;
  flex-wrap: nowrap !important;
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  row-gap: 0.5rem;
}

.rp-popup-buttons-go-to-cart {
  background: #6f1920;
  color: white;
  border-radius: 3px;
  height: 3rem;
}

.rp-popup-buttons-go-to-cart:hover {
  background: black;
}

.rp-popup-buttons-keep-shop {
  color: black;
  border-radius: 3px;
  height: 3rem;
  border: 1px solid black;
  background: white;
}

.rp-popup-buttons-keep-shop:hover {
  background: black;
  color: white;
}

.rp-buttons {
  width: 50%;
  margin: 1%;
}

.rp-popup-subtitle {
  margin-bottom: 0em !important;
}

@media (max-width: 880px) {
  .rp-popup-container {
    max-width: 80%;
  }

  .rp-popup-content {
    flex-direction: column;
  }

  .rp-popup-items {
    margin: 4%;
  }

  .rp-popup-image {
    height: 4em;
  }

  .rp-popup-buttons {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 16px;
  }

  .rp-buttons {
    width: 100%;
    margin: 8px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/product/components/Popup/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EAEE,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".rp-popup-container {\n  position: fixed;\n  top: 1% !important;\n  right: 1%;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fffdfb;\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);\n  z-index: 8001;\n  border-radius: 8px;\n  padding: 20px;\n  max-width: 40%;\n  transition: top 0.5s ease-in-out;\n}\n\n.rp-popup-container.visible {\n  top: 0%;\n}\n\n.rp-popup-icon {\n  margin-right: 5%;\n  max-width: 25px;\n  text-align: -webkit-center;\n}\n\n.rp-popup-items {\n  margin: 5% 1%;\n}\n\n.rp-popup-header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0 1%;\n}\n\n.rp-popup-content {\n  align-items: center;\n  flex-grow: 1;\n  width: 100%;\n  /* display: flex; */\n}\n\n.rp-popup-title {\n  margin-bottom: 0px !important;\n  font-size: 12px;\n  font-weight: 400;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #808080;\n}\n\n.rp-popup-product-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2%;\n  /* background: #f0f0f05c; */\n  border-radius: 3px;\n  padding: 0 1%;\n}\n\n.rp-popup-image {\n  height: 3.4em;\n  object-fit: cover;\n  border-radius: 3px;\n}\n\n.rp-popup-product-title {\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0em !important;\n  margin-left: 1em;\n  color: black;\n}\n\n.rp-popup-buttons {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  flex-wrap: nowrap !important;\n  display: flex;\n  flex-direction: row;\n  gap: 0.4rem;\n  row-gap: 0.5rem;\n}\n\n.rp-popup-buttons-go-to-cart {\n  background: #6f1920;\n  color: white;\n  border-radius: 3px;\n  height: 3rem;\n}\n\n.rp-popup-buttons-go-to-cart:hover {\n  background: black;\n}\n\n.rp-popup-buttons-keep-shop {\n  color: black;\n  border-radius: 3px;\n  height: 3rem;\n  border: 1px solid black;\n  background: white;\n}\n\n.rp-popup-buttons-keep-shop:hover {\n  background: black;\n  color: white;\n}\n\n.rp-buttons {\n  width: 50%;\n  margin: 1%;\n}\n\n.rp-popup-subtitle {\n  margin-bottom: 0em !important;\n}\n\n@media (max-width: 880px) {\n  .rp-popup-container {\n    max-width: 80%;\n  }\n\n  .rp-popup-content {\n    flex-direction: column;\n  }\n\n  .rp-popup-items {\n    margin: 4%;\n  }\n\n  .rp-popup-image {\n    height: 4em;\n  }\n\n  .rp-popup-buttons {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 16px;\n  }\n\n  .rp-buttons {\n    width: 100%;\n    margin: 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
